import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // Don't refetch on window focus automatically to avoid flicker if user is alt-tabbing
            staleTime: 1000 * 60 * 5, // Data is fresh for 5 minutes
            retry: 1,
        },
    },
});
